/*
| software | id |
| ---------- | --- |
| Maya | 2000 |
| 3ds Max | 2001 |
| Lightwave | 2002 |
| Arnold Standalone | 2003 |
| Houdini | 2004 |
| Cinema 4D | 2005 |
| Softimage | 2006 |
| Blender | 2007 |
| VR Standalone | 2008 |
| MR Standalone | 2009 |
| SketchUp | 2010 |
| VUE | 2011 |
| KeyShot | 2012 |
| Clarisse | 2013 |
| Octane Render | 2014 |
| Nuke | 2015 |
| Katana | 2016 |
| ContextCapture | 2017 |
| Terragen | 2018 |

*/

export const SoftwareID = Object.freeze({
  Maya: 2000,
  Max: 2001,
  Lightwave: 2002,
  ArnoldStandalone: 2003,
  Houdini: 2004,
  Cinema4D: 2005,
  Softimage: 2006,
  Blender: 2007,
  VRStandalone: 2008,
  MRStandalone: 2009,
  SketchUp: 2010,
  VUE: 2011,
  KeyShot: 2012,
  Clarisse: 2013,
  OctaneRender: 2014,
  Nuke: 2015,
  Katana: 2016,
  ContextCapture: 2017,
  Terragen: 2018,
  Creole: 2019,
  UnrealEngine: 2020,
  Gaffer: 2021,
  Vred: 2022,
  CustomSoftware: 2030,
})

export const TableData = [
  {
    param: '参数',
    ts: '{ts}',
    te: '{te}',
    tb: '{tb}',
    tpp: '{tpp}',
    tsf: '{tsf}',
    top: '{top}',
    null: '{null}',
  },
]

export const CgStatusList = [
  {label: 'deploy_plugin_enabled_all', value: 1},
  {label: 'deploy_plugin_enables_partial', value: 2},
  {label: 'deploy_plugin_disabled_all', value: 0},
]
